export default __webpack_public_path__ + "static/media/0-OFICINA.f46a0a62.jpg";